import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

interface EncryptionDTO {
  Payload: string;
  PublicKey: string;
}

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  private key: any = CryptoJS.enc.Utf8.parse(environment.encryptionKey); // Convert into WordArray (using Utf8)

  constructor() {}

  public decryptResponse(encryptedData: EncryptionDTO) {
    if (!encryptedData || !encryptedData.Payload || !encryptedData.PublicKey) {
      return null;
    }
  
    var decrypted = CryptoJS.AES.decrypt(
      encryptedData.Payload,
      this.key,
      {
        iv: CryptoJS.enc.Utf8.parse(encryptedData.PublicKey),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
  
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  

  public encryptPayload(plainText: string): EncryptionDTO {
    if(plainText == (null || "null" || "")) return null;
    const iv = Array.from({ length: 16 }, () => Math.floor(Math.random() * 10)).join('');
    const encrypted = CryptoJS.AES.encrypt(plainText, this.key, {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return { Payload: encrypted.toString(), PublicKey: iv };
  }
}
